function initWatchFilms(root) {
  const tabs = Array.from(root.querySelectorAll(".watch-films__tab"));
  const panels = Array.from(root.querySelectorAll(".watch-films__panel"));

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      const target = tab.dataset.tab;

      tabs.forEach((t) => {
        t.classList.toggle("is-active", t === tab);
        t.setAttribute("aria-selected", t === tab ? "true" : "false");
      });

      panels.forEach((panel) => {
        panel.classList.toggle("is-active", panel.dataset.panel === target);
      });
    });
  });
}

document.querySelectorAll("[data-watch-films]").forEach(initWatchFilms);

document.addEventListener("shopify:section:load", (event) => {
  const root = event.target.querySelector("[data-watch-films]");
  if (root) initWatchFilms(root);
});
